type SortableEvent = {
    date: Date;
    status: "upcoming" | "active" | "ended";
    isFeatured: boolean;
    featuredOrder: number | null;
};

/** Featured active/upcoming events are the ones shown in the carousels. */
export function isCarouselEvent(
    event: Omit<SortableEvent, "date" | "featuredOrder">,
) {
    return event.isFeatured && event.status !== "ended";
}

/**
 * Carousel events come first, ranked by FeaturedOrder (lower first, unset last).
 * Everything else is sorted by date, earliest first.
 */
export function compareEvents(a: SortableEvent, b: SortableEvent): number {
    const aCarousel = isCarouselEvent(a);
    const bCarousel = isCarouselEvent(b);
    if (aCarousel !== bCarousel) return aCarousel ? -1 : 1;

    if (aCarousel) {
        const orderDiff =
            (a.featuredOrder ?? Number.MAX_SAFE_INTEGER) -
            (b.featuredOrder ?? Number.MAX_SAFE_INTEGER);
        if (orderDiff !== 0) return orderDiff;
    }

    return a.date.getTime() - b.date.getTime();
}
